import { RouteVia, RouteViaLabels } from "../../../../enums/routeVia";
import {
  SubmissionSummaryRouteVia,
  SubmissionSummaryRouteViaLabels,
} from "../../../../enums/submissionSummaryRouteVia";

/**
 * Resolves a stored `route_via` value to a display label, checking BOTH
 * vocabularies that appear in pa_request_entries.route_via -- NYCBS/CMM
 * tracking writes SubmissionSummaryRouteVia values ("cmm"/"Evicore"/
 * "EOC ID"/"Form Only"/...), other pharmacy submission flows write RouteVia
 * values ("FaxPA"/"PromptPA"/"PhonePA"/"Surescripts"). Matching is
 * case-insensitive. Falls back to the raw value when neither vocabulary
 * recognizes it, rather than silently mislabeling it as something else.
 *
 * @input rawRouteVia - the stored route_via value, or null/undefined
 * @return the display label, or null when rawRouteVia is empty
 */
export const getRouteViaLabel = (
  rawRouteVia: string | null | undefined,
): string | null => {
  const trimmed = rawRouteVia?.trim();
  if (!trimmed) {
    return null;
  }

  const normalized = trimmed.toLowerCase();

  const knownRouteVia = Object.values(RouteVia).find(
    (value) => value.toLowerCase() === normalized,
  );
  if (knownRouteVia) {
    return RouteViaLabels[knownRouteVia];
  }

  const knownSubmissionSummaryRouteVia = Object.values(
    SubmissionSummaryRouteVia,
  ).find((value) => value.toLowerCase() === normalized);
  if (knownSubmissionSummaryRouteVia) {
    return SubmissionSummaryRouteViaLabels[knownSubmissionSummaryRouteVia];
  }

  return trimmed;
};
